<script lang="ts">
	import type { Snippet } from 'svelte';
	import CloseIcon from 'virtual:icons/material-symbols/close-rounded';
	import { getModalContext } from '@astlai/common/contexts/modal.context.svelte.ts';

	interface Props {
		header: Snippet;
		main: Snippet;
		actions?: Snippet;
		showClose?: boolean;
	}

	let { header, main, actions, showClose = true }: Props = $props();

	const modalCtx = getModalContext();
</script>

<div class="dialog-layout">
	<div class="header">
		<h1>{@render header()}</h1>
		{#if showClose}
			<button
				type="button"
				class="icon-button close-button"
				onclick={() => modalCtx.closeModal()}
				aria-label="Close"
			>
				<CloseIcon />
			</button>
		{/if}
	</div>

	<div class="main">
		{@render main()}
	</div>

	{#if actions}
		<div class="actions">
			{@render actions()}
		</div>
	{/if}
</div>

<style lang="scss">
	@use '@astlai/common/styles/mixins' as lib;

	.dialog-layout {
		@include lib.flex-column();
		gap: 1rem;
		min-height: 0;
		flex: 1 1 auto;
		padding-bottom: 1rem;
	}

	.header {
		@include lib.flex-row();
		@include lib.flex-align(space-between, center);
		flex-shrink: 0;
		padding: 1rem 1rem 0;

		.close-button {
			margin: -0.25rem;
		}

		h1 {
			font-size: 1rem;
			font-weight: 600;
			margin: 0;
			line-height: normal;
		}
	}

	.main {
		@include lib.flex-column();
		gap: 1rem;
		overflow-y: auto;
		min-height: 0;
		flex: 1 1 auto;
		padding: 0 1rem;
	}

	.actions {
		@include lib.flex-row();
		gap: 0.5rem;
		flex-shrink: 0;
		flex-wrap: wrap;
		padding: 0 1rem;

		> :global(button:last-child) {
			flex: 1 1 0;
		}

		> :global(button:not(:last-child)) {
			flex-shrink: 0;
		}
	}
</style>
